<div class="poll-card">
  <img loading="lazy" src="../../../../assets/images/new/forum.jpg" alt=""  [class.d-none]="hideImage"/>
  <div class="poll-card--header">
    <div class="name">{{ pollData.name }}</div>
    <div class="time">{{ pollData.remainingTime }} Left</div>
  </div>
  <div class="poll-card--body" wi>
    <!-- poll -->
    <ng-container *ngFor="let child of pollData.poll_details; let i = index">
      <div class="mb-1" *ngIf="(i < 5 && !pollData.showMore) || pollData.showMore">
        <div class="d-flex" style="gap: 0.5em">
          <div class="flex-grow-1 progress" style="height: 2rem; background-color: rgba(var(--black-rgb), var(--black-rgb), var(--black-rgb), 0.25)">
            <div class="progress-bar text-left" role="progressbar" style="overflow: unset !important" [style.width]="child.progress ?? 0" [style.backgroundColor]="pollsColor[i] != null ? pollsColor[i] : 'grey'" aria-valuenow="{{ child.progress?.replace('%', '') }}" aria-valuemin="0" aria-valuemax="100">
              <span class="px-3 fw-bolder" style="font-size: 16px"> {{ child.name }} ({{ child.poll_interactions.length }}) </span>
            </div>
          </div>
          <label class="progress-checkbox" [class.d-none]="isLogin" (click)="checkPoll(pollData, child)">
            <span class="checkmark mr-0"></span>
          </label>
          <label class="progress-checkbox" [class.d-none]="!isLogin">
            <input type="checkbox" [checked]="hasCheckedPoll(child.poll_interactions)" (change)="checkPoll(pollData, child)" />
            <span class="checkmark mr-0"></span>
          </label>
        </div>
      </div>
      <button class="btn btn-light text-center w-100" *ngIf="i == 4 && !pollData.showMore && pollData.poll_details.length - 5 != 0" (click)="pollData.showMore = true">
        Show {{ pollData.poll_details.length - 5 }} more
        <i class="fa-solid fa-chevron-down"></i>
      </button>


      <button class="btn btn-light text-center w-100" *ngIf="pollData.showMore && i == pollData.poll_details.length - 1" (click)="pollData.showMore = false">See less <i class="fa-solid fa-chevron-up"></i></button>
    </ng-container>
    <div class="btn btn-outline-secondary w-100"  *ngIf="showAdd"(click)="openNewOptionModal($event, newOptionPollingAdd, pollData)"><i class="fa-solid fa-plus"></i> Suggest New</div>

  </div>
 
</div>


<ng-template #newOptionPollingAdd let-modal>
  <div id="new_polling_option_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-body">
      <h5 class="text-center">New Polling Option {{ newPolling.title }}</h5>
      <div class="form-group">
        <label for="">Title</label>
        <input type="text" [(ngModel)]="newPolling.option" class="form-control" />
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-danger mr-2" [disabled]="newPolling?.hasSubmit" (click)="modalService.dismissAll()"><i
          class="fa-solid fa-times"></i> Cancel</button>
      <button class="btn btn-primary" (click)="newPollingStore()" [disabled]="newPolling?.hasSubmit"><i
          class="fa-solid fa-paper-plane"></i> Submit</button>
    </div>
  </div>
</ng-template>